/**
 * Responsive breakpoint hook for the admin dashboard.
 * Returns true when the viewport width is below the mobile breakpoint (900px).
 * Re-evaluates on window resize. SSR-safe.
 */

import { useEffect, useState } from 'react';

export function useIsMobile(mobileBreakpoint = 900): boolean {
  const [isMobile, setIsMobile] = useState<boolean>(() =>
    typeof window !== 'undefined'
      ? window.matchMedia(`(max-width: ${mobileBreakpoint - 1}px)`).matches
      : false,
  );

  useEffect(() => {
    const query = window.matchMedia(`(max-width: ${mobileBreakpoint - 1}px)`);
    const handler = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    query.addEventListener('change', handler);
    return () => query.removeEventListener('change', handler);
  }, [mobileBreakpoint]);

  return isMobile;
}
